import { StructureBuilder } from "sanity/structure";
import * as microContent from "../schemas/micro-content";
import { generateChildren } from "../utils/micro-content";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Website Micro-Content")
    .child(
      S.list()
        .title("Website Micro-Content")
        .items(generateChildren(S, microContent))
    );
